var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasLift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_35334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2998 449.8H854L853.5 567L757.2 519.5L647.7 572.6L560.4 527.1L454.1 599.8L323.2 637L239.6 584L205.1 536.8L123.8 575.6L103.6 527.1L28.1998 506.2L4.2998 449.8Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.2 573.4H132.5V698.5H187.2V573.4Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.4 542.4V699.4H188.2L188.4 528.9",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.4 542.4V699.4H188.2L188.4 528.9",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.8 544.7L198.1 527.2L122.8 544.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.8 544.7L198.1 527.2",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.8 693.1L82 689.6L131.6 686.7",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.8 693.1L82 689.6L131.6 686.7",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.8 676.3L81.7998 673.4L131.6 669.9",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.8 676.3L81.7998 673.4L131.6 669.9",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.8 668.9L236.3 672.9L187.8 676.7",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.8 668.9L236.3 672.9L187.8 676.7",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.2 686L236.5 690.9L188.1 694",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.2 686L236.5 690.9L188.1 694",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.3 534.3V446.6H186.9V522.1",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.3 534.3V446.6H186.9V522.1",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5 447.6L131.4 464.2L186.4 455.3V447.5L131.5 447.6Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 478.9V463.3L177.4 457.2V473.1L141 478.9Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 478.8L140.6 532L141 478.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 478.8L140.6 532",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.4 472.5V524.1V472.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.4 472.5V524.1",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.3 650.5H132.4V663H151.3V650.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 662.3L132.5 650.4L151 662.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 662.3L132.5 650.4",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.7 662.1L150.9 650.8L132.7 662.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.7 662.1L150.9 650.8",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.3 639.1H178.9H169.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.3 639.1H178.9",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.2 640.4V628V640.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.2 640.4V628",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.2 529.6L150.3 478L169 475.1L169.2 525.2L150.2 529.6Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.2 386.5H21.7998V401.7H498.2V386.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.6 198.5H154.6V269.7H166.6V198.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8 267.9H151.5V324.3H169.8V267.9Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.2 322.3H140.7V343.9H181.2V322.3Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.7 431.4H121.7V441.4H196.7V431.4Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.5 439.4H117.5V448.4H200.5V439.4Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.8 370.3H131.4V431.2H189.8V370.3Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.8 375.5H122.8V379H128.8V375.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.4 375.5H131.4V379H137.4V375.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.1 375.5H140.1V379H146.1V375.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.7 375.5H148.7V379H154.7V375.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.3 375.5H157.3V379H163.3V375.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 375.5H166V379H172V375.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.6 375.5H174.6V379H180.6V375.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.2 375.5H183.2V379H189.2V375.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.9 375.5H191.9V379H197.9V375.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.3 340.7H117.5V376H203.3V340.7Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.8 337.5H122.8V341H128.8V337.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.4 337.5H131.4V341H137.4V337.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.1 337.5H140.1V341H146.1V337.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.7 337.5H148.7V341H154.7V337.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.3 337.5H157.3V341H163.3V337.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 337.5H166V341H172V337.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.6 337.5H174.6V341H180.6V337.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.2 337.5H183.2V341H189.2V337.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.9 337.5H191.9V341H197.9V337.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.1 370.5C162.364 370.5 164.2 368.664 164.2 366.4C164.2 364.135 162.364 362.3 160.1 362.3C157.836 362.3 156 364.135 156 366.4C156 368.664 157.836 370.5 160.1 370.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5 358H203.3H117.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5 358H203.3",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770 229.5L787.3 215.8L177.5 215.6L177.4 229.8L770 229.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.2 213.3H418.3V233.1H433.2V213.3Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.9 208.9H422.8V236.9H428.9V208.9Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.7 213.3H486.3V233.1H522.7V213.3Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8 204.6H151.5V241.9H169.8V204.6Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.9 214.1L165.6 222.2L169.9 231.1L178.5 231.3L178.7 214.2L169.9 214.1Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.2 383.8H55.6001V404.7H105.2V383.8Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.6 383.8H206V404.7H255.6V383.8Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.6 314.8C171.259 314.8 179.9 306.159 179.9 295.5C179.9 284.841 171.259 276.2 160.6 276.2C149.941 276.2 141.3 284.841 141.3 295.5C141.3 306.159 149.941 314.8 160.6 314.8Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.6 305.6C165.626 305.6 169.7 301.526 169.7 296.5C169.7 291.474 165.626 287.4 160.6 287.4C155.574 287.4 151.5 291.474 151.5 296.5C151.5 301.526 155.574 305.6 160.6 305.6Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.8 286.6C166.733 286.6 168.3 285.033 168.3 283.1C168.3 281.167 166.733 279.6 164.8 279.6C162.867 279.6 161.3 281.167 161.3 283.1C161.3 285.033 162.867 286.6 164.8 286.6Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.6 291.9C173.533 291.9 175.1 290.333 175.1 288.4C175.1 286.467 173.533 284.9 171.6 284.9C169.667 284.9 168.1 286.467 168.1 288.4C168.1 290.333 169.667 291.9 171.6 291.9Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.2 299.5C176.133 299.5 177.7 297.933 177.7 296C177.7 294.067 176.133 292.5 174.2 292.5C172.267 292.5 170.7 294.067 170.7 296C170.7 297.933 172.267 299.5 174.2 299.5Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.6 307.1C173.533 307.1 175.1 305.533 175.1 303.6C175.1 301.667 173.533 300.1 171.6 300.1C169.667 300.1 168.1 301.667 168.1 303.6C168.1 305.533 169.667 307.1 171.6 307.1Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.1 312.3C167.033 312.3 168.6 310.733 168.6 308.8C168.6 306.867 167.033 305.3 165.1 305.3C163.167 305.3 161.6 306.867 161.6 308.8C161.6 310.733 163.167 312.3 165.1 312.3Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.3 312.3C158.233 312.3 159.8 310.733 159.8 308.8C159.8 306.867 158.233 305.3 156.3 305.3C154.367 305.3 152.8 306.867 152.8 308.8C152.8 310.733 154.367 312.3 156.3 312.3Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.7 307.5C151.633 307.5 153.2 305.933 153.2 304C153.2 302.067 151.633 300.5 149.7 300.5C147.767 300.5 146.2 302.067 146.2 304C146.2 305.933 147.767 307.5 149.7 307.5Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.8 299.7C148.733 299.7 150.3 298.133 150.3 296.2C150.3 294.267 148.733 292.7 146.8 292.7C144.867 292.7 143.3 294.267 143.3 296.2C143.3 298.133 144.867 299.7 146.8 299.7Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.3 291.7C151.233 291.7 152.8 290.133 152.8 288.2C152.8 286.267 151.233 284.7 149.3 284.7C147.367 284.7 145.8 286.267 145.8 288.2C145.8 290.133 147.367 291.7 149.3 291.7Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.3 286.6C158.233 286.6 159.8 285.033 159.8 283.1C159.8 281.167 158.233 279.6 156.3 279.6C154.367 279.6 152.8 281.167 152.8 283.1C152.8 285.033 154.367 286.6 156.3 286.6Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.6 342.4C186.999 342.4 208.4 320.999 208.4 294.6C208.4 268.201 186.999 246.8 160.6 246.8C134.201 246.8 112.8 268.201 112.8 294.6C112.8 320.999 134.201 342.4 160.6 342.4Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6 247.8L159.9 296L151.6 247.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6 247.8L159.9 296",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.7 295.6L124.3 322.4L159.7 295.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.7 295.6L124.3 322.4",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9 294.6L204.7 312.3L159.9 294.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9 294.6L204.7 312.3",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5002 413.1C91.1593 413.1 99.8002 404.459 99.8002 393.8C99.8002 383.141 91.1593 374.5 80.5002 374.5C69.8411 374.5 61.2002 383.141 61.2002 393.8C61.2002 404.459 69.8411 413.1 80.5002 413.1Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4999 403.9C85.5257 403.9 89.5999 399.826 89.5999 394.8C89.5999 389.774 85.5257 385.7 80.4999 385.7C75.4741 385.7 71.3999 389.774 71.3999 394.8C71.3999 399.826 75.4741 403.9 80.4999 403.9Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7002 384.9C86.6332 384.9 88.2002 383.333 88.2002 381.4C88.2002 379.467 86.6332 377.9 84.7002 377.9C82.7672 377.9 81.2002 379.467 81.2002 381.4C81.2002 383.333 82.7672 384.9 84.7002 384.9Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5 390.2C93.433 390.2 95 388.633 95 386.7C95 384.767 93.433 383.2 91.5 383.2C89.567 383.2 88 384.767 88 386.7C88 388.633 89.567 390.2 91.5 390.2Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1001 397.8C96.0331 397.8 97.6001 396.233 97.6001 394.3C97.6001 392.367 96.0331 390.8 94.1001 390.8C92.1671 390.8 90.6001 392.367 90.6001 394.3C90.6001 396.233 92.1671 397.8 94.1001 397.8Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5 405.5C93.433 405.5 95 403.933 95 402C95 400.067 93.433 398.5 91.5 398.5C89.567 398.5 88 400.067 88 402C88 403.933 89.567 405.5 91.5 405.5Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 410.6C86.933 410.6 88.5 409.033 88.5 407.1C88.5 405.167 86.933 403.6 85 403.6C83.067 403.6 81.5 405.167 81.5 407.1C81.5 409.033 83.067 410.6 85 410.6Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2002 410.6C78.1332 410.6 79.7002 409.033 79.7002 407.1C79.7002 405.167 78.1332 403.6 76.2002 403.6C74.2672 403.6 72.7002 405.167 72.7002 407.1C72.7002 409.033 74.2672 410.6 76.2002 410.6Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6001 405.8C71.5331 405.8 73.1001 404.233 73.1001 402.3C73.1001 400.367 71.5331 398.8 69.6001 398.8C67.6671 398.8 66.1001 400.367 66.1001 402.3C66.1001 404.233 67.6671 405.8 69.6001 405.8Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7002 398C68.6332 398 70.2002 396.433 70.2002 394.5C70.2002 392.567 68.6332 391 66.7002 391C64.7672 391 63.2002 392.567 63.2002 394.5C63.2002 396.433 64.7672 398 66.7002 398Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2002 390C71.1332 390 72.7002 388.433 72.7002 386.5C72.7002 384.567 71.1332 383 69.2002 383C67.2672 383 65.7002 384.567 65.7002 386.5C65.7002 388.433 67.2672 390 69.2002 390Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2002 384.9C78.1332 384.9 79.7002 383.333 79.7002 381.4C79.7002 379.467 78.1332 377.9 76.2002 377.9C74.2672 377.9 72.7002 379.467 72.7002 381.4C72.7002 383.333 74.2672 384.9 76.2002 384.9Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5002 422.2C96.406 422.2 109.3 409.306 109.3 393.4C109.3 377.494 96.406 364.6 80.5002 364.6C64.5944 364.6 51.7002 377.494 51.7002 393.4C51.7002 409.306 64.5944 422.2 80.5002 422.2Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2998 363.4L80.6998 395.6L75.2998 363.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2998 363.4L80.6998 395.6",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2001 393.8L59.6001 413.5L81.2001 393.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2001 393.8L59.6001 413.5",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8999 394.1L105.4 406.1L80.8999 394.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8999 394.1L105.4 406.1",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.4 413.3C240.059 413.3 248.7 404.659 248.7 394C248.7 383.341 240.059 374.7 229.4 374.7C218.741 374.7 210.1 383.341 210.1 394C210.1 404.659 218.741 413.3 229.4 413.3Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.4 404.1C234.426 404.1 238.5 400.026 238.5 395C238.5 389.974 234.426 385.9 229.4 385.9C224.374 385.9 220.3 389.974 220.3 395C220.3 400.026 224.374 404.1 229.4 404.1Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.6 385C235.533 385 237.1 383.433 237.1 381.5C237.1 379.567 235.533 378 233.6 378C231.667 378 230.1 379.567 230.1 381.5C230.1 383.433 231.667 385 233.6 385Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.4 390.4C242.333 390.4 243.9 388.833 243.9 386.9C243.9 384.967 242.333 383.4 240.4 383.4C238.467 383.4 236.9 384.967 236.9 386.9C236.9 388.833 238.467 390.4 240.4 390.4Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 398C244.933 398 246.5 396.433 246.5 394.5C246.5 392.567 244.933 391 243 391C241.067 391 239.5 392.567 239.5 394.5C239.5 396.433 241.067 398 243 398Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.4 405.6C242.333 405.6 243.9 404.033 243.9 402.1C243.9 400.167 242.333 398.6 240.4 398.6C238.467 398.6 236.9 400.167 236.9 402.1C236.9 404.033 238.467 405.6 240.4 405.6Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.9 410.8C235.833 410.8 237.4 409.233 237.4 407.3C237.4 405.367 235.833 403.8 233.9 403.8C231.967 403.8 230.4 405.367 230.4 407.3C230.4 409.233 231.967 410.8 233.9 410.8Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.1 410.8C227.033 410.8 228.6 409.233 228.6 407.3C228.6 405.367 227.033 403.8 225.1 403.8C223.167 403.8 221.6 405.367 221.6 407.3C221.6 409.233 223.167 410.8 225.1 410.8Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 406C220.433 406 222 404.433 222 402.5C222 400.567 220.433 399 218.5 399C216.567 399 215 400.567 215 402.5C215 404.433 216.567 406 218.5 406Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.6 398.2C217.533 398.2 219.1 396.633 219.1 394.7C219.1 392.767 217.533 391.2 215.6 391.2C213.667 391.2 212.1 392.767 212.1 394.7C212.1 396.633 213.667 398.2 215.6 398.2Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.1 390.2C220.033 390.2 221.6 388.633 221.6 386.7C221.6 384.767 220.033 383.2 218.1 383.2C216.167 383.2 214.6 384.767 214.6 386.7C214.6 388.633 216.167 390.2 218.1 390.2Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.1 385C227.033 385 228.6 383.433 228.6 381.5C228.6 379.567 227.033 378 225.1 378C223.167 378 221.6 379.567 221.6 381.5C221.6 383.433 223.167 385 225.1 385Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.4 422.4C245.306 422.4 258.2 409.506 258.2 393.6C258.2 377.694 245.306 364.8 229.4 364.8C213.494 364.8 200.6 377.694 200.6 393.6C200.6 409.506 213.494 422.4 229.4 422.4Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.2 365L230 395.7L224.2 365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.2 365L230 395.7",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.6 393.9L208.5 410.8L229.6 393.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.6 393.9L208.5 410.8",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.3 394.2L256.7 405.8L229.3 394.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.3 394.2L256.7 405.8",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.8 383.8H282.9V404.7H320.8V383.8Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.257 375.643V385.243L302.457 388.943L311.657 385.143V375.643H293.257Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.3 383.8H354.1V404.7H378.3V383.8Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 381.9H364.5V406.5H380V381.9Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 381.1H370.6V407.4H380V381.1Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.9 379.4H372.3V409H379.9V379.4Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.6 212H728.3V216.8H739.6V212Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758 212H746.7V216.8H758V212Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.6 203.5H730.1V213.4H737.6V203.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.1 203.5H748.6V213.1H756.1V203.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.7 199.1H726.3V205.3H759.7V199.1Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758 183.2H728.3V200.2H758V183.2Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.7 183.2C755.629 183.2 765.3 173.529 765.3 161.6C765.3 149.671 755.629 140 743.7 140C731.771 140 722.1 149.671 722.1 161.6C722.1 173.529 731.771 183.2 743.7 183.2Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.6 181.3C754.48 181.3 763.3 172.48 763.3 161.6C763.3 150.72 754.48 141.9 743.6 141.9C732.72 141.9 723.9 150.72 723.9 161.6C723.9 172.48 732.72 181.3 743.6 181.3Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.6 154.6H728.9V168.8H758.6V154.6Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.7 194.1H151.4V198H169.7V194.1Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.957 187.586H143.557V193.786H176.957V187.586Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.186 170.8H145.486V187.8H175.186V170.8Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.571 369.972H286.171V376.172H319.571V369.972Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.871 352.671H288.171V369.671H317.871V352.671Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.5 351.4C315.429 351.4 325.1 341.73 325.1 329.8C325.1 317.871 315.429 308.2 303.5 308.2C291.571 308.2 281.9 317.871 281.9 329.8C281.9 341.73 291.571 351.4 303.5 351.4Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.5 349.5C314.38 349.5 323.2 340.68 323.2 329.8C323.2 318.92 314.38 310.1 303.5 310.1C292.62 310.1 283.8 318.92 283.8 329.8C283.8 340.68 292.62 349.5 303.5 349.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.7 342.3L291.8 339.3L287.7 342.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.7 342.3L291.8 339.3",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5 342L314.8 339.4L318.5 342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5 342L314.8 339.4",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.8 329H322.8H319.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.8 329H322.8",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.9 325.1L287.6 325.6L284.9 325.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.9 325.1L287.6 325.6",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.6 318.6L289.8 320.6L287.6 318.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.6 318.6L289.8 320.6",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.9 313.9L293.7 316.7L291.9 313.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.9 313.9L293.7 316.7",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.5 311.2L298.6 314.6L297.5 311.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.5 311.2L298.6 314.6",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.7 310.3V313.8V310.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.7 310.3V313.8",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.7 311.1L308.4 314.2L309.7 311.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.7 311.1L308.4 314.2",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.2 313.4L313.1 316L315.2 313.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.2 313.4L313.1 316",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 318.1L316.9 319.7L319 318.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 318.1L316.9 319.7",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.9 323.5L319.5 324.6L321.9 323.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.9 323.5L319.5 324.6",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.1 335.2L285.3 336.5L288.1 335.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.1 335.2L285.3 336.5",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.6 329.2L310.8 316.8L303.6 329.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.6 329.2L310.8 316.8",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.6 332.7C305.146 332.7 306.4 331.446 306.4 329.9C306.4 328.354 305.146 327.1 303.6 327.1C302.054 327.1 300.8 328.354 300.8 329.9C300.8 331.446 302.054 332.7 303.6 332.7Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.4 334.6L321.9 335.5L319.4 334.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.4 334.6L321.9 335.5",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.7 324.9C522.9 354.7 509.4 391.4 497.8 400.5L496.5 401.8C481.6 420 456.2 412.9 439 404",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.7 324.9C522.9 354.7 509.4 391.4 497.8 400.5L496.5 401.8C481.6 420 456.2 412.9 439 404",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486 324.4C485 344.3 494.9 351.4 504.8 373.8L486 324.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486 324.4C485 344.3 494.9 351.4 504.8 373.8",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.9 250.3C494.5 240.1 484.8 233.8 472 230.3L500.9 250.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.9 250.3C494.5 240.1 484.8 233.8 472 230.3",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.6 238.3H499.4V446.2H510.6V238.3Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.2 438.8H497.7V449.4H512.2V438.8Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.8 385.4H493.3V404.2H503.8V385.4Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.3 383.4H497.2V405.8H512.3V383.4Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.8 232.4H495.4V242.3H514.8V232.4Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.1 249.8H467.9V325.5H542.1V249.8Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538 252.9H471.4V322.2H538V252.9Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.3 240.7H519.9V249.6H538.3V240.7Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.5 142.6H523.7V240.7H534.5V142.6Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.2 112.1V162.1V112.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.2 112.1V162.1",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5 330.4H287.1H284.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5 330.4H287.1",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.574 696.507L151.274 539.405L169.974 534.388L169.774 696.821L152.574 696.507Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.99996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.6 535.4L198 518.4L123.6 535.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.6 535.4L198 518.4",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.8 649.4H169.8V661.9H188.8V649.4Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.1 661.1L169.6 649.9L188.1 661.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.1 661.1L169.6 649.9",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8 662L189 649.4L169.8 662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8 662L189 649.4",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8 558.5H179.4H169.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8 558.5H179.4",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8 578.3H179.4H169.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8 578.3H179.4",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8 597.7H179.4H169.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8 597.7H179.4",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8 617.9H179.4H169.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8 617.9H179.4",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.4 558.8V546.3V558.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.4 558.8V546.3",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.4 579V566.5V579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.4 579V566.5",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.4 598.4V585.9V598.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.4 598.4V585.9",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.4 618.5V606V618.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.4 618.5V606",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.3 662.7H133V698.5H188.3V662.7Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.2 661H152.6V663.4H169.2V661Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.7 383.8H413.5V404.7H437.7V383.8Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.8 379.3H430.2V408.9H437.8V379.3Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5 171.1C172.429 171.1 182.1 161.429 182.1 149.5C182.1 137.571 172.429 127.9 160.5 127.9C148.571 127.9 138.9 137.571 138.9 149.5C138.9 161.429 148.571 171.1 160.5 171.1Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.6 169.2C171.48 169.2 180.3 160.38 180.3 149.5C180.3 138.62 171.48 129.8 160.6 129.8C149.72 129.8 140.9 138.62 140.9 149.5C140.9 160.38 149.72 169.2 160.6 169.2Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.8 162L148.9 159L144.8 162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.8 162L148.9 159",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.6 161.7L171.9 159.1L175.6 161.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.6 161.7L171.9 159.1",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.9 148.7H179.9H176.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.9 148.7H179.9",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 144.7L144.7 145.2L142 144.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 144.7L144.7 145.2",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.7 138.3L146.9 140.3L144.7 138.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.7 138.3L146.9 140.3",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 133.6L150.8 136.4L149 133.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 133.6L150.8 136.4",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.6 130.9L155.7 134.3L154.6 130.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.6 130.9L155.7 134.3",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.8 130V133.5V130Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.8 130V133.5",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.8 130.7L165.5 133.8L166.8 130.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.8 130.7L165.5 133.8",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.2 133.1L170.1 135.7L172.2 133.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.2 133.1L170.1 135.7",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.1 137.8L174 139.4L176.1 137.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.1 137.8L174 139.4",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 143.1L176.6 144.2L179 143.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 143.1L176.6 144.2",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.2 154.9L142.4 156.2L145.2 154.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.2 154.9L142.4 156.2",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.7 148.9L167.9 136.5L160.7 148.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.7 148.9L167.9 136.5",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.7 152.4C162.246 152.4 163.5 151.146 163.5 149.6C163.5 148.053 162.246 146.8 160.7 146.8C159.154 146.8 157.9 148.053 157.9 149.6C157.9 151.146 159.154 152.4 160.7 152.4Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.4 154.3L178.9 155.2L176.4 154.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.4 154.3L178.9 155.2",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.6 150.1H144.2H141.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.6 150.1H144.2",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.7 116.1V158.1V116.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.7 116.1V158.1",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.2 120.1V154.1V120.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.2 120.1V154.1",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.6 124.1V150.1V124.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.6 124.1V150.1",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.1 128.1V146.1V128.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.1 128.1V146.1",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.7 142.6H520.4V132H537.7V137.3V142.6Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.5 137.1H537.7",
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_35334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 790,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasLift);
export default __webpack_public_path__ + "static/media/gas-lift.bc1125e728817ef70d38847903c17056.svg";
export { ForwardRef as ReactComponent };